module.exports = __webpack_public_path__ + "img/coffee-set.ba3d3d2c.svg";